module.exports = __webpack_public_path__ + "img/buildings-2.d10429c8.svg";